<template>
  <simple-card-dialog
    v-model:dialog="model"
    max-width="450"
    show-cancel
    :title="title"
  >
    <UserGroupForm
      ref="form"
      :current-data="currentData"
      :create-from-parent="createFromParent"
      @form-data="updateFormData"
    />

    <template #actions>
      <action-button
        save
        @click="submit()"
      />
    </template>
  </simple-card-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CreateEditMixin from './CreateEditMixin'
  import UserGroupForm from '@/components/forms/UserGroupForm'

  export default {
    components: {
      UserGroupForm
    },
    mixins: [CreateEditMixin],
    props: {
      createFromParent: {
        type: Number,
        default: null
      }
    },
    data: () => ({
      api: 'user-groups'
    }),
    computed: {
      ...mapGetters(['login', 'ui']),
      title () {
        let mode
        if (this.currentData) {
          mode = this.$t('Edit')
        } else {
          mode = this.$t('Create')
        }
        return this.$t('UserGroup.UserGroups') + ' (' + mode + ')'
      }
    }
  }
</script>
